export default "__VITE_ASSET__BstuoxJT__"